import React from 'react';
import { connect } from 'react-redux';
import getProjectId from '../../services/mini/getProjectId';
import PageLoader from '../components/PageLoader/PageLoader';
import NoProjectFound from '../components/NoProjectFound/NoProjectFound';
import NoPageFound from '../components/NoPageFound/NoPageFound';
import { isUserBalancePositive } from '../../services/mini/isUserBalancePositive';
import { routeInfo } from '../../routeInfo';
import { get } from 'lodash';
import history from '../../history';

class DataLoaderContainer extends React.PureComponent {

    componentDidMount() {
        this.checkIfBalancePositive();
    }

    componentDidUpdate() {
        this.checkIfBalancePositive();
    }

    checkIfBalancePositive() {
        const {
            hasProfileData,
            children,
            user
        } = this.props;
        const isPositiveBalanceRequired = children.props.route.isPositiveBalanceRequired;

        if (hasProfileData && isPositiveBalanceRequired) {
            if (!isUserBalancePositive(user)) {
                history.replace(routeInfo.billing.url())
            }
        }
    }

    render() {
        const {
            hasProfileData,
            hasProjectsData,
            projectId,
            children,
            features
        } = this.props;

        let needUserData = !children.props.route.noAuthRequired;
        const isProjectRequired = children.props.route.isProjectRequired;
        const isPositiveBalanceRequired = children.props.route.isPositiveBalanceRequired;
        const isAllowedPath = children.props.route.isAllowedPath;
        const isAllowed = isAllowedPath ? get(features, children.props.route.isAllowedPath) : true;
        const isLoginPage = children.props.route.path === routeInfo.login.path ||
            children.props.route.path === routeInfo.index.path;

        if (children.props.route.path === '/oops') {
            needUserData = false;
        }

        if (needUserData && !hasProfileData && !isLoginPage) {
            return <PageLoader />;
        }
        if (isAllowedPath && features === null) {
            return <PageLoader />;
        }
        if (isPositiveBalanceRequired && !hasProfileData) {
            return <PageLoader />;
        }
        if (isProjectRequired) {
            if (!hasProjectsData) {
                return <PageLoader />;
            }
            if (hasProjectsData && !projectId) {
                return <NoProjectFound />;
            }
        }
        if (!isAllowed) {
            return <NoPageFound />;
        }
        return this.props.children;
    }
}

function mapStateToProps({ projectsInfo, user, config }, ownProps) {
    const params = ownProps.children.props.params;
    const projectId = getProjectId(params.projectName, projectsInfo.projects);
    return {
        hasProfileData: user.hasProfileData,
        user: user,
        hasProjectsData: projectsInfo.hasProjectsData,
        projectId,
        features: config.features
    };
}
function mapDispatchToProps(dispatch) {
    return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(DataLoaderContainer);